<template>
  <Layout>
    <div class="reward-container">
      <h2>Claim Your Reward</h2>
      <div>
        <p>{{ message }}</p>
        <el-button v-if="rewardAvailable" type="primary" @click="claimReward">
          Claim Now
        </el-button>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/Partials/Layout";
import api from "@/http/api";
import detectEthereumProvider from "@metamask/detect-provider";

export default {
  components: { Layout },
  data() {
    return {
      rewardAvailable: false,
      message: "",
    };
  },
  mounted() {
    this.checkReward();
  },
  methods: {
    async checkReward() {
      const loading = this.$loading({
        lock: true,
        text: "Checking for rewards, please wait...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });
      try {
        const rewardRes = await api.hasClaim({
          userId: this.$store.state.userInfo.userId,
        });
        if (rewardRes.data.data) {
          this.rewardAvailable = true;
        }
        this.message = rewardRes.data.data
          ? "Hi! You have unclaimed rewards!"
          : "Currently, you don't have any rewards. Please connect your data to earn rewards.";
      } catch (err) {
        console.log(err);
      } finally {
        loading.close();
      }
    },
    async claimReward() {
      const loading = this.$loading({
        lock: true,
        text: "Claiming reward, Please wait…",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });
      try {
        if (typeof window.ethereum === "undefined") {
          this.$alert("MetaMask is not installed or connected, please check");
          loading.close();
          return;
        }
        // 绑定用户钱包
        const provider = await detectEthereumProvider();
        const accounts = await provider.request({
          method: "eth_requestAccounts",
        });
        let toAddress = "";
        if (accounts.length > 0) {
          toAddress = window.ethereum.selectedAddress;
        }
        await api.registerWallet({
          userId: this.$store.state.userInfo.userId,
          address: toAddress,
        });
        await api.redeemClaim({
          userId: this.$store.state.userInfo.userId,
        });
        this.$alert(
          "Reward claimed successfully! It may take a few minutes to reflect in your wallet."
        );
        sessionStorage.setItem("rewardAvailable", false);
        this.message =
          "Currently, you don't have any rewards. Please connect your data to earn rewards.";

        this.rewardAvailable = false;
      } catch (err) {
        console.log(err);
      } finally {
        loading.close();
      }
    },
  },
};
</script>

<style scoped>
.reward-container {
  max-width: 400px;
  margin: 40px auto;
  padding: 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
  text-align: center;
}
.message {
  margin-top: 16px;
  color: green;
}
button {
  padding: 10px 20px;
  font-size: 16px;
}
</style>
